import { DesktopBalance } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/DesktopBalance";
import { MobileBalance } from "Components/Dashboard/BalanceWithPaymentActions/MobileBalance/MobileBalance";
import { useIsMobile } from "Hooks/useIsMobile";

export const BalanceWithPaymentActions = () => {
  const isMobile = useIsMobile();

  return isMobile ? <MobileBalance /> : <DesktopBalance />;
};
